module.exports = __webpack_public_path__ + "/images/ico-cover-refund.b4dc881.svg";